import Structure from 'components/3catinfo/Structure';
import styles from './estructura.module.scss';

export default function Estructura(props) {
    const { tag, id } = props;
    const TagHtml = tag;
    return (
        <TagHtml className={styles[tag]} id={id}>
            <Structure {...props} />
        </TagHtml>
    );
}
